"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateConfig = exports.deleteConfigById = exports.deleteBatchConfigById = exports.addConfig = void 0;
var _api = _interopRequireDefault(require("@/libs/api.request"));
/**
 * 添加配置
 * @param config
 * @returns {ClientHttp2Stream | * | AxiosPromise<any> | ClientRequest | void}
 */
var addConfig = exports.addConfig = function addConfig(config) {
  return _api.default.request({
    url: '/system/config/save',
    method: 'post',
    data: config
  });
};

/**
 * 修改配置
 * @param config
 * @returns {ClientHttp2Stream | * | AxiosPromise<any> | ClientRequest | void}
 */
var updateConfig = exports.updateConfig = function updateConfig(config) {
  return _api.default.request({
    url: '/system/config/update',
    method: 'post',
    data: config
  });
};

/**
 * 删除配置
 * @param configId
 * @returns {ClientHttp2Stream | * | AxiosPromise<any> | ClientRequest | void}
 */
var deleteConfigById = exports.deleteConfigById = function deleteConfigById(configId) {
  return _api.default.request({
    url: '/system/config/delete',
    method: 'post',
    params: {
      id: configId
    }
  });
};

/**
 * 批量删除配置
 * @param configIds
 * @returns {ClientHttp2Stream | * | AxiosPromise<any> | ClientRequest | void}
 */
var deleteBatchConfigById = exports.deleteBatchConfigById = function deleteBatchConfigById(configIds) {
  return _api.default.request({
    url: '/system/config/deleteBatch',
    method: 'post',
    data: configIds
  });
};